// extracted by mini-css-extract-plugin
export var btn = "F_mB z_tR z_tw d_bz d_bP d_bD d_dw";
export var full = "F_wq d_w d_H";
export var hoverStyle = "F_mF";
export var zoom = "F_mG";